module.exports = __webpack_public_path__ + "img/SliderAr.cc25b174.jpg";